import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

const initialState = {
  list: [],
  status: 'idle',
  error: null,
};

// fetch all addresses for current user
export const fetchAddresses = createAsyncThunk(
  'addresses/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/auth/addresses/');
      return res.data;
    } catch (e) {
      return rejectWithValue('Не удалось загрузить адреса');
    }
  }
);

export const addAddress = createAsyncThunk(
  'addresses/add',
  async (address, { rejectWithValue }) => {
    try {
      const res = await api.post('/auth/addresses/', { address });
      return res.data;
    } catch (e) {
      return rejectWithValue('Не удалось добавить адрес');
    }
  }
);

export const updateAddress = createAsyncThunk(
  'addresses/update',
  async ({ id, address }, { rejectWithValue }) => {
    try {
      const res = await api.patch(`/auth/addresses/${id}/`, { address });
      return res.data;
    } catch (e) {
      return rejectWithValue('Не удалось обновить адрес');
    }
  }
);

export const deleteAddress = createAsyncThunk(
  'addresses/delete',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/auth/addresses/${id}/`);
      return id;
    } catch (e) {
      return rejectWithValue('Не удалось удалить адрес');
    }
  }
);

const addressesSlice = createSlice({
  name: 'addresses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddresses.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload.results || action.payload;
      })
      .addCase(fetchAddresses.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(addAddress.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })

      .addCase(updateAddress.fulfilled, (state, action) => {
        const idx = state.list.findIndex((a) => a.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })

      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.list = state.list.filter((a) => a.id !== action.payload);
      });
  },
});

export default addressesSlice.reducer;
